// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__1EsPU","Indicador":"mexico_Indicador__2uRaG","FadeIn":"mexico_FadeIn__3YcE1","fadeIn":"mexico_fadeIn__3C-Mq"};